import { render, staticRenderFns } from "./summary-report-pension-fund-and-insurance.vue?vue&type=template&id=a3d48aac&scoped=true&"
import script from "./summary-report-pension-fund-and-insurance.vue?vue&type=script&lang=js&"
export * from "./summary-report-pension-fund-and-insurance.vue?vue&type=script&lang=js&"
import style0 from "./summary-report-pension-fund-and-insurance.vue?vue&type=style&index=0&id=a3d48aac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d48aac",
  null
  
)

export default component.exports